import config from 'config';
import sfax from './sfax';

let { loginDomain, loginOriginDomain,houseDomain } = config;

export default {
    getInfo: payload => sfax({
        // url: loginDomain + '/passport/getUserInfo',
        url: loginOriginDomain + '/passport/getUserInfo',
        jsonp: true,
        data: payload,
        contentType: 'application/x-javascript;charset=UTF-8'
    }),
    getAuthorDetail: payload => sfax({
        // url: loginDomain + '/passport/getUserInfo',
        url: houseDomain + '/baseApi/authorDetail',
        jsonp: false,
        data: payload
    })
};



// WEBPACK FOOTER //
// ./src/model/api/user.js